import styled from 'styled-components';
import { plainCard, plainCardGroup, text_s, heading_s, link } from '_utils/styles';
import { Link } from 'react-router-dom';
import { spacing } from '_utils/props';

export const Card = styled.article`
  ${({ theme }) => plainCard({ theme })}
  /* overflow: hidden; */
  @media print {
    width: 60%;
  }
`;

export const Group = styled.div`
  ${({ theme }) => plainCardGroup({ theme })}
  ${text_s}
  margin: 0;
`;

export const LinkHeading = styled(Link)`
  ${link}
  display: inline;

  /* need to refactor this into a theme function */
  ${heading_s}

  & + div {
    ${({ theme }) => spacing({ theme, $mt: { xs: 1 } })}
  }
`;

export const AddressTag = styled.address`
  font-style: normal;
  ${text_s}
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;
